import Vue from 'vue'
//设置dialog弹窗与浏览器顶部距离
Vue.directive('alterELDialogMarginTop',{
  inserted(el, binding, vnode) {
    el.firstElementChild.style.marginTop = binding.value.marginTop
  }
})


// WEBPACK FOOTER //
// ./src/util/dialogTop.js